import React from "react";
import { BilingualField, Panel, Repeater, TextField, Toggle } from "@/components/studio/Fields";

/* Affiliate partners. The token is stitched onto the outgoing link when the
   page is served — it travels in the href, which is how the programme credits
   the sale — so keeping it here rather than in every link means rotating it is
   a single edit. */

export const AffiliatePanel = ({ draft, set }) => {
  const affiliates = draft.affiliates || {};

  return (
    <Panel
      title="Affiliation"
      hint="Vos partenaires et votre identifiant. L’identifiant est ajouté au lien au moment où la page part — c’est ainsi que le programme vous crédite la vente. Le stocker ici plutôt que dans chaque lien vous permet d’en changer d’un seul geste."
    >
      <Toggle
        label="Afficher les recommandations sur le site"
        hint="Désactivé, rien n’apparaît — ni les partenaires, ni la mention légale."
        checked={affiliates.enabled}
        onChange={(value) => set("affiliates.enabled", value)}
        testId="affiliates-enabled"
      />

      <BilingualField
        label="Titre de la section"
        value={affiliates.title}
        onChange={(value) => set("affiliates.title", value)}
        testId="affiliates-title"
      />
      <BilingualField
        label="Mention légale"
        hint="Obligatoire dès qu’un lien est rémunéré. Elle s’affiche dans le pied de page."
        value={affiliates.disclosure}
        onChange={(value) => set("affiliates.disclosure", value)}
        rows={3}
        testId="affiliates-disclosure"
      />

      <div className="mt-6">
        <Repeater
          items={affiliates.partners || []}
          onChange={(next) => set("affiliates.partners", next)}
          blank={() => ({
            name: "",
            network: "",
            url: "",
            token: "",
            token_param: "tag",
            blurb: { fr: "", en: "" },
            image_url: "",
            active: true,
          })}
          addLabel="Ajouter un partenaire"
          testId="affiliate-partners"
          renderItem={(item, patch) => (
            <>
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <TextField
                  label="Nom"
                  value={item.name}
                  onChange={(value) => patch({ name: value })}
                  testId={`partner-name-${item.id || "new"}`}
                />
                <TextField
                  label="Programme"
                  hint="Amazon Partenaires, Awin, un partenariat direct…"
                  value={item.network}
                  onChange={(value) => patch({ network: value })}
                  testId={`partner-network-${item.id || "new"}`}
                />
                <TextField
                  label="Lien"
                  value={item.url}
                  onChange={(value) => patch({ url: value })}
                  placeholder="https://…"
                  testId={`partner-url-${item.id || "new"}`}
                />
                <TextField
                  label="Image"
                  value={item.image_url}
                  onChange={(value) => patch({ image_url: value })}
                  placeholder="https://…"
                  testId={`partner-image-${item.id || "new"}`}
                />
                <TextField
                  label="Votre identifiant"
                  hint="Le code que le programme vous a attribué."
                  value={item.token}
                  onChange={(value) => patch({ token: value })}
                  testId={`partner-token-${item.id || "new"}`}
                />
                <TextField
                  label="Nom du paramètre"
                  hint="« tag » chez Amazon, souvent « ref » ou « aff » ailleurs. C’est ce qui précède votre identifiant dans le lien."
                  value={item.token_param}
                  onChange={(value) => patch({ token_param: value })}
                  placeholder="tag"
                  testId={`partner-param-${item.id || "new"}`}
                />
              </div>

              {item.url && item.token ? (
                <p className="font-num mt-3 break-all text-[11px] text-[color:var(--muted-ink)]">
                  {`${item.url}${item.url.includes("?") ? "&" : "?"}${item.token_param || "tag"}=${item.token}`}
                </p>
              ) : null}

              <BilingualField
                label="Pourquoi vous le recommandez"
                value={item.blurb}
                onChange={(value) => patch({ blurb: value })}
                rows={2}
                testId={`partner-blurb-${item.id || "new"}`}
              />
              <Toggle
                label="Actif"
                checked={item.active !== false}
                onChange={(value) => patch({ active: value })}
                testId={`partner-active-${item.id || "new"}`}
              />
            </>
          )}
        />
      </div>
    </Panel>
  );
};

export default AffiliatePanel;
